import { request } from './client';

export interface AuthTokenResponse {
  accessToken: string;
  expiresAt?: string | number | null;
  csrfToken?: string | null;
}

/** The saas-auth cookie surface: refresh at boot and on the bounded 401 retry; logout on sign-out. */
export const authApi = {
  refresh(): Promise<AuthTokenResponse> {
    return request<AuthTokenResponse>('POST', '/api/auth/refresh', { json: {} });
  },
  logout(): Promise<void> {
    return request<void>('POST', '/api/auth/logout', { json: {} });
  },
};
